import { VIRTUAL_TOUR_EVENT, VIRTUAL_TOUR_TABS } from '../../components/virtual-tour/constant'

export const HOTSPOT_ACTIONS = {
  'hotspot--virtual-tour': {
    overlay: true,
    message: null,
    mode: VIRTUAL_TOUR_TABS.INTERIOR,
  },
  'hotspot--virtual-tour-external': {
    overlay: true,
    message: null,
    mode: VIRTUAL_TOUR_TABS.EXTERIOR,
  },
  'hotspot--sound-system': {
    overlay: false,
    message: 'hotspot.soundSystem',
  },
  'hotspot--all-wheel-control': {
    overlay: false,
    message: 'hotspot.allWheelControl',
  },
  'hotspot--safety-features': {
    overlay: false,
    message: 'hotspot.safetyFeatures',
  },
  'hotspot--mitsubishi-connect': {
    overlay: false,
    message: 'hotspot.mitsubishiConnect',
  },
  'hotspot--warranty': {
    overlay: false,
    message: 'hotspot.warranty',
  },
  'hotspot--s-awc': {
    overlay: false,
    message: 'hotspot.SAWC',
  },
  'hotspot--cargo-space': {
    overlay: false,
    message: 'hotspot.cargoSpace',
  },
}
